var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBntImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    enableBackground: "new 0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 16,
    cy: 16.001,
    r: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.05,10.232c-0.894-0.496-2.018-0.173-2.514,0.718l-3.423,6.167l-1.963-1.961c-0.721-0.721-1.889-0.721-2.609,0 c-0.721,0.721-0.721,1.889,0,2.609l3.693,3.691C14.581,21.805,15.052,22,15.538,22c0.085,0,0.171-0.008,0.255-0.02 c0.574-0.082,1.078-0.424,1.359-0.932l4.615-8.307C22.264,11.852,21.939,10.729,21.05,10.232L21.05,10.232z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBntImg);
export default __webpack_public_path__ + "static/media/bntImg.25abaa20892d2e6ddc0415a495e91185.svg";
export { ForwardRef as ReactComponent };